import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { FormikProps } from 'formik';
import { ContentSpacer } from '../../../../TCSMApp/global/components/layout/generic-content-spacer';
import { Wysiwyg } from '../wysiwyg';
import { buttonStyles } from '../../../../TCSMApp/global/constants/theme/styles/components/buttonstyles';

interface FormikErrorDisplayProps {
	formikProps: FormikProps<any>;
	formKeys?: string[];
	onCancel: () => any;
}
export function FormikErrorSummary(props: FormikErrorDisplayProps) {
	const classes = buttonStyles();
	const { errors, touched, values } = props.formikProps;

	const filteredKeys: { [key: string]: string } = {};

	const fieldNames = props.formKeys || Object.keys(values);

	// only want to display errors for touched fields or non field specific 
	let errorKeys = Object.keys(errors).filter(key => !fieldNames.includes(key) || touched[key]);

	if (errorKeys.length < 1) return null;

	errorKeys.forEach(a => { filteredKeys[errors[a] as string] = a; });
	errorKeys = Object.keys(filteredKeys).map(a => filteredKeys[a]);

	const handleErrorClick = (key: string) => {
		const scrollOptions: ScrollIntoViewOptions = {
			behavior: 'smooth',
			block: 'center',
		};

		const element = document.querySelector(`[data-formdata=${key}]`);
		if (element) {
			if (element.previousElementSibling) {
				element.previousElementSibling.scrollIntoView(scrollOptions);
			} else {
				element.scrollIntoView(scrollOptions);
			}
		} else if (props.onCancel) {
			props.onCancel();

			// Try to go back and try again.
			setTimeout(
				() => {
					const elementBack = document.querySelector(`[data-formdata=${key}]`);
					if (elementBack) {
						if (elementBack.previousElementSibling) {
							elementBack.previousElementSibling.scrollIntoView(scrollOptions);
						} else {
							elementBack.scrollIntoView(scrollOptions);
						}
					}
				}, 1000);
		}
	};

	return (
		<ContentSpacer>
			<Banner
				banner={{
					type: 'error',
					label: <p><strong>{`${errorKeys.length} error(s) were found in this form.`}</strong></p>,
					description: <ul>
						{errorKeys.map((key) => {
							if (!errors[key]) {
								return null;
							}
							if (!fieldNames.includes(key)) {
								return (
									<li key={key}>
										<p><Wysiwyg content={errors[key] as string} /></p>
									</li>
								);
							}
							if (Array.isArray(errors[key])) {
								return (errors[key] as any[]).map((error, idx) => {
									if (!error) {
										return null;
									}
									const nestedKeys = Object.keys(error);

									return nestedKeys.map(k => {
										return (
											<button type='button' title={k} onClick={() => handleErrorClick(`"${key}[${idx}].${k}"`)} className={classes.linkButton}>
												<li key={key}>
													<p><Wysiwyg content={error[k] as string} /></p>
												</li>
											</button>

										);
									});
								});
							}

							if (typeof errors[key] === 'object') {
								return Object.keys(k => {
									return (
										<li key={key}>
											<p><Wysiwyg content={errors[key][k] as string} /></p>
										</li>
									);
								});
							}

							return (
								<li key={key}>
									<button type='button' title={key} onClick={() => handleErrorClick(key)} className={classes.linkButton}>
										<Wysiwyg content={errors[key] as string} />
									</button>
								</li>
							);
						})}
					</ul>,
				}}
			/>

		</ContentSpacer>
	);
}

FormikErrorSummary.defaultProps = {
	formKeys: null,
};